import React, { useEffect } from 'react';
import PageHeader from '../innovher/PageHeader';
import { IMG } from '../../lib/images';
import SEO from '../SEO';

export default function Xlr8arPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    const els = document.querySelectorAll('.reveal-up');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  const gallery = [
    IMG.eventXlr8ar1,
    IMG.eventXlr8ar2,
    IMG.eventXlr8ar3,
    IMG.eventXlr8ar4,
    IMG.eventXlr8ar5,
    IMG.eventXlr8ar6,
    IMG.eventXlr8ar8
  ];

  return (
    <>
      <SEO 
        title="XLR8AR | InnovHer Event"
        description="InnovHer's signature XLR8AR gathering brings industry leaders, investors and founders together in Jaipur for scale-up conversations and connections."
        keywords="XLR8AR, InnovHer event, Jaipur startup summit, Rajasthan entrepreneurship"
      />
      <PageHeader
        eyebrow="Signature Event"
        title={<><span className="text-[#ff8ec5]">XLR8AR</span> 2025</>}
        subtitle="On January 9, 2025, Innovher hosted XLR8AR - An innovation jamboree uniting founders, investors, and business leaders for a high-energy startup acceleration event."
        image={IMG.eventXlr8ar2}
        breadcrumbs={[{ label: 'Events', to: '#' }, { label: 'XLR8AR' }]}
      />

      <section className="relative bg-[#08080a] py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          
          <div className="reveal-up max-w-4xl mx-auto text-center mb-24">
            <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-white mb-8">Empowering Startups & Driving Innovation</h2>
            <p className="text-lg text-white/60 leading-relaxed text-justify md:text-center">
              The day featured startup pitching, thematic deliberations, and deep-dive discussions on innovation in tech, hospitality, and lifestyle industries. Attendees explored investment opportunities, business collaborations, and global connections, fostering a dynamic entrepreneurial ecosystem. Key moments included interactive strategy sessions, expert panels, and networking meetups, providing startups with a platform to scale and thrive. The event concluded with a grand networking dinner, reinforcing Innovher’s mission to empower startups and drive impactful innovation.
            </p>
          </div>

          <div className="reveal-up mb-24">
            <h3 className="text-2xl font-bold text-white mb-8 border-l-4 border-[#ff8ec5] pl-4">XLR8AR 2.O</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-4 auto-rows-[250px] md:auto-rows-[300px] gap-4 md:gap-6">
              {[
                IMG.eventXlr8ar2_1, IMG.eventXlr8ar2_2, IMG.eventXlr8ar2_3,
                IMG.eventXlr8ar2_4, IMG.eventXlr8ar2_5, IMG.eventXlr8ar2_6,
                IMG.eventXlr8ar2_7, IMG.eventXlr8ar2_8, IMG.eventXlr8ar2_9,
                IMG.eventXlr8ar2_10
              ].map((src, i) => {
                const getBentoClasses = (index) => {
                  switch(index % 6) {
                    case 0: return "md:col-span-2 md:row-span-2";
                    case 3: return "md:col-span-2 md:row-span-1";
                    default: return "md:col-span-1 md:row-span-1";
                  }
                };
                return (
                <div key={i} className={`relative group rounded-3xl overflow-hidden bg-white/5 border border-white/10 ${getBentoClasses(i)}`}>
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-500 z-10 pointer-events-none" />
                  <img 
                    src={src} 
                    alt={`XLR8AR 2.O Event Gallery ${i + 1}`} 
                    className="absolute inset-0 w-full h-full object-contain transform group-hover:scale-105 transition-transform duration-700" 
                    loading="lazy"
                  />
                </div>
              )})}
            </div>
          </div>

          <div className="reveal-up">
            <h3 className="text-2xl font-bold text-white mb-8 border-l-4 border-[#ff8ec5] pl-4">Previous Event Gallery</h3>
            
            <div className="grid grid-cols-1 md:grid-cols-4 auto-rows-[250px] md:auto-rows-[300px] gap-4 md:gap-6">
              {gallery.map((src, i) => {
                const getBentoClasses = (index) => {
                  switch(index) {
                    case 0: return "md:col-span-2 md:row-span-2";
                    case 1: return "md:col-span-2 md:row-span-1";
                    case 2: return "md:col-span-1 md:row-span-2";
                    default: return "md:col-span-1 md:row-span-1";
                  }
                };
                
                return (
                <div key={i} className={`relative group rounded-3xl overflow-hidden bg-white/5 border border-white/10 ${getBentoClasses(i)}`}>
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-500 z-10 pointer-events-none" />
                  <img 
                    src={src} 
                    alt={`XLR8AR Event Gallery ${i + 1}`} 
                    className="absolute inset-0 w-full h-full object-contain transform group-hover:scale-105 transition-transform duration-700" 
                    loading="lazy"
                  />
                </div>
              )})}
            </div>
          </div>

        </div>
      </section>
    </>
  );
}
